/**
 * Animations Module
 * 
 * @package KateMedia
 */

export function initAnimations() {
    const elements = document.querySelectorAll('[data-animate]');
    
    if (elements.length === 0) {
        return;
    }
    
    elements.forEach((el) => {
        if (el.classList.contains('efficiency__partner') && el.getAttribute('data-animate') === 'scale') {
            el.style.pointerEvents = 'none';
            el.style.willChange = 'transform';
        }
        
        el.style.willChange = 'transform, opacity';
    });
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const delayAttr = entry.target.getAttribute('data-animate-delay');
                const parsedDelay = delayAttr ? parseInt(delayAttr, 10) : 0;
                const clampedDelay = Math.min(Math.max(parsedDelay, 0), 1000);
                
                if (clampedDelay > 0) {
                    setTimeout(() => {
                        entry.target.classList.add('animated');
                        
                        if (entry.target.getAttribute('data-animate') === 'scale') {
                            setTimeout(() => {
                                entry.target.style.pointerEvents = 'auto';
                                entry.target.style.willChange = 'auto';
                            }, 100);
                        } else {
                            setTimeout(() => {
                                entry.target.style.willChange = 'auto';
                            }, 600);
                        }
                    }, clampedDelay);
                } else {
                    entry.target.classList.add('animated');
                    
                    if (entry.target.getAttribute('data-animate') === 'scale') {
                        setTimeout(() => {
                            entry.target.style.pointerEvents = 'auto';
                            entry.target.style.willChange = 'auto';
                        }, 100);
                    } else {
                        setTimeout(() => {
                            entry.target.style.willChange = 'auto';
                        }, 600);
                    }
                }
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -1px 0px'
    });
    
    elements.forEach(el => observer.observe(el));
}
